import { Card, CardActions, CardContent, IconButton, Typography } from "@mui/material";
import React from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export interface CardButtonProps {
  icon?: React.ReactNode;
  text: string;
  secondaryText?: string;
  secondaryTextPosition?: 'left' | 'right';
  showArrow?: boolean;
  showMore?: boolean;
  showLess?: boolean;
  style?: React.CSSProperties;
  iconButtonStyle?: React.CSSProperties;
  onClick?: (event?: React.MouseEvent) => void;
  children?: React.ReactNode;
}

function CardButton(props: CardButtonProps) {
  const cardStyle: React.CSSProperties = {
    marginBottom: 10,
    ...props.style,
  };

  const iconButtonStyle: React.CSSProperties = {
    ...props.iconButtonStyle,
    marginLeft: 'auto',
  };

  let secondaryTextStyle: React.CSSProperties = {};
  switch (props.secondaryTextPosition) {
    case 'left':
      secondaryTextStyle = {
        marginLeft: 10,
      };
      break;
    case 'right':
      secondaryTextStyle = {
        marginRight: 10,
        marginLeft: 'auto',
      };
      break;
  }

  return (
    <Card style={cardStyle}>
      <CardActions disableSpacing onClick={(event) => {
        if (props.onClick) {
          props.onClick(event);
        }
      }}>
        { props.icon && <IconButton style={props.iconButtonStyle}>
          { props.icon }
        </IconButton> }
        { props.secondaryText && props.secondaryTextPosition === 'left' && <Typography variant="body2" style={secondaryTextStyle}>
          { props.secondaryText }
        </Typography> }
        <Typography variant="body1" style={{
          paddingLeft: 10,
        }}>
          { props.text }
        </Typography>
        { props.secondaryText && props.secondaryTextPosition === 'right' && <Typography variant="body2" style={secondaryTextStyle}>
          { props.secondaryText }
        </Typography> }
        { props.showArrow &&
        <IconButton style={iconButtonStyle}>
          <ArrowForwardIosIcon />
        </IconButton> }
        { props.showMore &&
        <IconButton style={iconButtonStyle}>
          <ExpandMoreIcon />
        </IconButton> }
        { props.showLess &&
        <IconButton style={iconButtonStyle}>
          <ExpandLessIcon />
        </IconButton> }
      </CardActions>
      { props.children && 
        <CardContent>
          { props.children }
        </CardContent>
      }
    </Card>
  );
}

export default CardButton;
